import type { TabId } from '../components/BottomNav'
import type { MessageKey } from '../i18n/messages'
import type { TutorialStepId } from './types'

type TutorialStepDef = {
  tab: TabId
  targetId: string
  titleKey: MessageKey
  bodyKey: MessageKey
  tooltipPosition: 'above' | 'below' | 'auto'
}

export const TUTORIAL_STEPS: Record<TutorialStepId, TutorialStepDef> = {
  hideout_resources: {
    tab: 'hideout',
    targetId: 'resource-strip',
    titleKey: 'tutorial_hideout_resources_title',
    bodyKey: 'tutorial_hideout_resources_body',
    tooltipPosition: 'below',
  },
  hideout_workstations: {
    tab: 'hideout',
    targetId: 'workstation-grid',
    titleKey: 'tutorial_hideout_workstations_title',
    bodyKey: 'tutorial_hideout_workstations_body',
    tooltipPosition: 'auto',
  },
  nav_tabs: {
    tab: 'hideout',
    targetId: 'bottom-nav',
    titleKey: 'tutorial_nav_tabs_title',
    bodyKey: 'tutorial_nav_tabs_body',
    tooltipPosition: 'above',
  },
  survivors_list: {
    tab: 'survivors',
    targetId: 'survivor-list',
    titleKey: 'tutorial_survivors_list_title',
    bodyKey: 'tutorial_survivors_list_body',
    tooltipPosition: 'auto',
  },
  stash_items: {
    tab: 'stash',
    targetId: 'stash-items',
    titleKey: 'tutorial_stash_items_title',
    bodyKey: 'tutorial_stash_items_body',
    tooltipPosition: 'auto',
  },
  expeditions_locations: {
    tab: 'expeditions',
    targetId: 'expedition-locations',
    titleKey: 'tutorial_expeditions_locations_title',
    bodyKey: 'tutorial_expeditions_locations_body',
    tooltipPosition: 'auto',
  },
  quests_quest: {
    tab: 'quests',
    targetId: 'quest-list',
    titleKey: 'tutorial_quests_quest_title',
    bodyKey: 'tutorial_quests_quest_body',
    tooltipPosition: 'auto',
  },
  quests_milestones: {
    tab: 'quests',
    targetId: 'milestones-tab',
    titleKey: 'tutorial_quests_milestones_title',
    bodyKey: 'tutorial_quests_milestones_body',
    tooltipPosition: 'above',
  },
}

export const TUTORIAL_STEP_ORDER: TutorialStepId[] = [
  'hideout_resources',
  'hideout_workstations',
  'nav_tabs',
  'survivors_list',
  'stash_items',
  'expeditions_locations',
  'quests_quest',
  'quests_milestones',
]
